import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { BookSection } from "../components/BookSection";
import { AuthorSection } from "../components/AuthorSection";
import { Praise } from "../components/Praise";
import { BuySection } from "../components/BuySection";
import { ComingSoon } from "../components/ComingSoon";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <main className="overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <BookSection />
      <AuthorSection />
      <Praise />
      <BuySection />
      <ComingSoon />
      <Footer />
    </main>
  );
}
